import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";

export function useResultCommentCreate(captureId: number, callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["resultCommentCreate", captureId],
    async (commentText: string) => apiContext.resultsApis.createResultComments(captureId, commentText),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
